import React from 'react';
import { getLcn } from '~/utils/labeled-classnames';
import { useChartEditContext } from './ChartEditContext';
import BeatInput from '../BeatInput';
import AdminArea from '~/shared/layouts/AdminArea';
import ChartLegacyInputs from './ChartLegacyInputs';
import dotPropImmutable from 'dot-prop-immutable';
import { TextField } from '@mui/material';

export default function ChartChordInputs() {
  const lcn = getLcn({
    chartChordInputs: ''
  });
  const {
    editedChart,
    edit_location,
    setEditLocation,
    setEditedChart,
    sectionColorClass,
  } = useChartEditContext();

  const onEditInputFocus = (e: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    e.target.select()
    setEditLocation(e.target.name)
  }

  return (
    <div className={lcn.chartChordInputs}>
      {editedChart.chords.map(
        (chord_section, chord_section_i) => {
          const sectionLabelPath = `chords.${chord_section_i}.label`
          const sectionNotePath = `chords.${chord_section_i}.note`

          return (
            <div key={`chord_section_${chord_section_i}`} className="section chord_section">
              <div className="flex gap-2 mb-2">
                <div className="w-1/2">
                  <input
                    placeholder='Section Label'
                    type='text'
                    className={`text-sm bg-transparent border border-gray-600 rounded px-1 dark inline section-label ${sectionColorClass(chord_section.label || '')}`}
                    onChange={(e) => setEditedChart(draft => dotPropImmutable.set(draft, sectionLabelPath, e.target.value))}

                    value={chord_section.label || ''}
                    onFocus={onEditInputFocus}
                  />
                </div>
                {/* <div className="w-1/2 text-right">
                  <input
                    placeholder='Section Note'
                    type='text'
                    className='text-sm bg-transparent border border-gray-600 rounded px-1 dark inline'
                    onChange={(e) => setEditedChart(draft => dotPropImmutable.set(draft, sectionNotePath, e.target.value))}
                    value={chord_section.note || ''}
                    onFocus={onEditInputFocus}
                  />
                </div> */}
              </div>

              <table className='chords'>
                <tbody>
                  {chord_section.lines.map(
                    (line, line_i) => {
                      const lineNotePath = `chords.${chord_section_i}.lines.${line_i}.note`
                      return (
                        <tr key={line_i}>
                          {line.measures.map(
                            (measure, measure_i) => (
                              <td key={measure_i} className="measure">
                                {measure.beats.map(
                                  (beat, beat_i) => {
                                    const beatPath = `chords.${chord_section_i}.lines.${line_i}.measures.${measure_i}.beats.${beat_i}`
                                    return (
                                      <BeatInput
                                        key={beatPath}
                                        path={beatPath}
                                        beat_i={beat_i}
                                        beat={beat}
                                        edit_location={edit_location}
                                        onEditInputFocus={onEditInputFocus}
                                      />
                                    )
                                  }
                                )}
                              </td>
                            )
                          )}
                          <td>
                            <input
                              placeholder='Line Text'
                              type='text'
                              className='text-sm bg-transparent border border-gray-600 rounded px-1 dark note'
                              onChange={(e) => setEditedChart(draft => dotPropImmutable.set(draft, lineNotePath, e.target.value))}
                              value={line.note || ''}
                              onFocus={onEditInputFocus}
                            />
                          </td>
                        </tr>
                      )
                    }
                  )}
                </tbody>
              </table>

            </div>
          )
        }
      )}
      <div className="section">
        <TextField
          placeholder='Song Notes'
          name="notes"
          size="small"
          variant='filled'
          multiline
          fullWidth
          minRows={3}
          onChange={(e) => setEditedChart(draft => dotPropImmutable.set(draft, 'notes', e.target.value))}
          rows={3}
          value={editedChart.notes || ''}
        />
      </div>

      <AdminArea showLock={false}>
        <ChartLegacyInputs />
      </AdminArea>
    </div>
  )
}

